import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CommonPagePromo } from 'components/no-auth/common/CommonPagePromo';
import { LightDiskButton } from 'components/no-auth/common/fromAuth/LightDiskButton/LightDiskButton';
import { LightHeaderPanel } from 'components/no-auth/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { LightIcon } from 'components/no-auth/common/fromAuth/LightIcon/LightIcon';
import { LightText } from 'components/no-auth/common/fromAuth/LightText/LightText';
import { MobileHelpLink } from 'components/no-auth/help/styles';
import ZendeskHelpMobileSearch from 'components/no-auth/help/ZendeskHelpMobileSearch';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'components/no-auth/utils';

import { toggleSpinner } from 'actions/appAction';
import { toggleChat } from 'actions/chatAction';

import { getLangCountryPrefix } from 'helpers/utils';

const ZendeskHelpMobileSectionPage = (props) => {
    let { sectionId } = useParams();
    const sectionIdNumber = Number(sectionId);
    const section = props.sections?.find((s) => s.id === sectionIdNumber);

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;
    const urlParams = useGetQueryParams();

    const articles = props.articles?.map((article) => {
        return (
            <MobileHelpLink
                key={article.id}
                href={getHelpCenterUrl(`${url}/category/${props.category.id}/section/${sectionId}/article/${article.id}`, urlParams)}
            >
                <LightText useThemeColor>{article.name}</LightText>
                <LightIcon useThemeColor name="chevron-right" color={'purple'} leftIndent={'16px'} />
            </MobileHelpLink>
        );
    });

    return (
        <CommonPagePromo
            useThemeColor
            backUrl={section?.directLink ? null : getHelpCenterUrl(`${url}/category/${props.category.id}`, urlParams)}
            type={'tagA'}
            rightHeaderComponent={
                !urlParams.platform ? (
                    <LightDiskButton
                        type={'tagA'}
                        href={props.backUrl}
                        onClick={() => {
                            props.toggleSpinner(true);
                            sessionStorage?.removeItem('prevUrl');
                        }}
                        iconName={'cross'}
                        useThemeColor
                    />
                ) : null
            }
        >
            <LightHeaderPanel useThemeColor title={section?.name} />
            <ZendeskHelpMobileSearch isMobilePlatform={urlParams.platform === 'ios' || urlParams.platform === 'android'} />
            {articles}
        </CommonPagePromo>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    articles: extra?.zendeskHelpData?.articles,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat, toggleSpinner })(NotAuthBasePage(ZendeskHelpMobileSectionPage));
